import { Center, Flex, Text, Box } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import { TransactionType } from "@constants/types";
import { TransactionIconMapping } from "./utils";
import FooterButtons from "./components/FooterButtons";
import GainOpportunities from "@components/DepositModal/GainOpportunities";
import { POST_CLAIM_MODAL_VAULT_PROMPT } from "@constants/analytics";
import React from "react";

interface SuccessErrorModalBodyTemplateProps {
  transactionType?: TransactionType;
  modalTitle: string;
  modalSubTitle?: string;
  extraText: string;
  onSubscribe?: () => void;
  primaryBtnTxt?: string; // view transactions
  onSubmitPrimary?: () => void;
  secondaryBtnTxt?: string; // view transactions
  onSubmitSecondary?: () => void;
  hideGainOpportunities?: boolean;
  transactionDetails?: React.ReactNode;
}

const ClaimELModal = ({
  primaryBtnTxt,
  transactionType,
  modalTitle,
  modalSubTitle,
  onSubscribe,
  onSubmitPrimary,
  secondaryBtnTxt,
  onSubmitSecondary,
  hideGainOpportunities = false,
  transactionDetails,
}: SuccessErrorModalBodyTemplateProps) => {
  const handleSubscribe = () => {
    if (onSubscribe) {
      onSubscribe();
    }
  };

  return (
    <Center
      textAlign="center"
      flexDir="column"
      w={{ base: "100%", md: "max-content" }}
      my="24px"
      mx={{ base: "0", md: "24px" }}
    >
      {transactionType && (
        <BaseImage
          src={TransactionIconMapping[transactionType].icon}
          width={48}
          height={48}
          alt="icon"
        />
      )}
      <Text
        mt="1rem"
        fontSize={{
          base: "20px",
          md: "24px",
        }}
        lineHeight="28px"
      >
        {modalTitle}
      </Text>

      <Flex
        mt="1rem"
        fontSize={transactionDetails ? "16px" : "14px"}
        fontWeight="400"
        textAlign="center"
        color="textSecondary"
        gap="4px"
        mb="20px"
      >
        <Text>{modalSubTitle ? modalSubTitle : transactionDetails}</Text>
      </Flex>

      {!hideGainOpportunities && (
        <GainOpportunities
          closeModal={handleSubscribe}
          action={handleSubscribe}
          hasActionButton={false}
          eventName={POST_CLAIM_MODAL_VAULT_PROMPT}
        />
      )}

      {primaryBtnTxt || secondaryBtnTxt ? (
        <Box mt="24px">
          <FooterButtons
            primaryBtnTxt={primaryBtnTxt}
            onSubmitPrimary={onSubmitPrimary}
            secondaryBtnTxt={secondaryBtnTxt}
            onSubmitSecondary={onSubmitSecondary}
          />
        </Box>
      ) : null}

      {/*
      <Box mt="24px" w="100%">
       <Text
          fontSize={{ base: "12px", md: "14px" }}
          fontWeight="400"
          lineHeight={{ base: "16px", md: "20px" }}
          color="textSecondary"
          mb="12px"
        >
          {extraText}
        </Text>

        <SubscribeEmail
          value={email}
          onChange={(value) => setEmail(value)}
          handleSubmit={handleSubmit}
          isDisabled={isSubscribing}
        /> 
        {error && (
          <Text textStyle="p14" color="#e53e3e" mt="0.5rem" textAlign="left">
            {error}
          </Text>
        )}
      </Box>
    */}
    </Center>
  );
};

export default ClaimELModal;
